module.exports = __webpack_public_path__ + "static/media/logo-2-dark.bce740e0.png";